var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.info)?_c('div',{staticClass:"sign_up_campaign",style:({backgroundColor: _vm.teamsiteConfig.color})},[_c('div',{staticClass:"sign_up_campaign__info",domProps:{"innerHTML":_vm._s(_vm.info)}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ccdb3b62","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SignUpCampaignBadge.vue
// module id = null
// module chunks = 